// Redux store for project IFC models keyed by id.
import _ from "lodash";

import {
  GET_PROJECT_IFC_MODELS,
  GET_PROJECT_IFC_MODEL,
  CREATE_PROJECT_IFC_MODEL,
  UPDATE_PROJECT_IFC_MODEL,
  DESTROY_PROJECT_IFC_MODEL,
} from "./actions";

export function ProjectIfcModelsReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_PROJECT_IFC_MODELS}_FULFILLED`: {
      return _.mapKeys(action.payload.data, "id");
    }
    case `${GET_PROJECT_IFC_MODEL}_FULFILLED`:
    case `${CREATE_PROJECT_IFC_MODEL}_FULFILLED`:
    case `${UPDATE_PROJECT_IFC_MODEL}_FULFILLED`: {
      const newState = _.clone(state);
      const newItem = action.payload.data;
      const id = _.get(newItem, "id");
      newState[id] = newItem;
      return newState;
    }
    case `${DESTROY_PROJECT_IFC_MODEL}_FULFILLED`: {
      const id = _.get(action.payload.data, "id");
      return _.omit(state, [id, String(id)]);
    }
    default:
      return state;
  }
}
